import * as firebase from 'firebase/app';
import 'firebase/auth';

const config = {
  apiKey: 'AIzaSyBtaqlzYhYXbtR3ayC6c3yfMI0QORT01V4',
  authDomain: 'portal-corretor-mobile.firebaseapp.com',
  databaseURL: 'https://portal-corretor-mobile.firebaseio.com',
  projectId: 'portal-corretor-mobile',
  storageBucket: 'portal-corretor-mobile.appspot.com',
  messagingSenderId: '854503321382',
  appId: '1:854503321382:web:43530f600128f02b355be7',
  measurementId: 'G-E479DKVTE4',
}



// const config = {
//   apiKey: "AIzaSyDrZ60LWIxvgDKoRLBiHVNlstLj2YH8u2c",
//   authDomain: "portal-guerini-dev-corretores.firebaseapp.com",
//   databaseURL: "https://portal-guerini-dev-corretores.firebaseio.com",
//   projectId: "portal-guerini-dev-corretores",
//   storageBucket: "portal-guerini-dev-corretores.appspot.com",
//   messagingSenderId: "826476491439",
//   appId: "1:826476491439:web:e6b08f8970befe67759a5a",
//   measurementId: "G-GV3ZKB88TF"
// }

firebase.initializeApp(config);

export const auth = firebase.auth
export const authConfig = config;

export const getCurrentUser = () => new Promise((resolve) => {
  auth().onAuthStateChanged(resolve);
});

export const getCurrentUserToken = async () => {
  const user = await  getCurrentUser();
  const tokenResult = await user.getIdTokenResult();

  return tokenResult.token;
};

export default {
  auth,
  authConfig,
  getCurrentUser,
  getCurrentUserToken
};
